import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-secondary-300/60 bg-secondary-50 mb-5">
            <span className="text-xs font-semibold text-secondary-700">Browse Products</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Explore All Product Categories
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Find the perfect items organized across our complete range of product categories
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/60 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} category — LitBuy spreadsheet tracking`}
                  title={`${cat.name} Products`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-3 mb-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-200 flex-shrink-0">
                    <i className={`${cat.icon} text-sm`}></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700">
                  View Items
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}